export default __webpack_public_path__ + "static/media/marriage_high.e078122f.png";